import React from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';

const OBSERVADAS_URL = 'https://autogestion.cokiba.org.ar/web/?q=devoluciones';

export default function FacturacionObservada() {
  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <h4 className="title">Facturación Observada por CoKiBA</h4>
            </CardHeader>
            <CardBody>
              <p>Visualizar tu Facturación Observada por CoKiBA</p>
              <Button
                color="primary"
                href={OBSERVADAS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver Facturación Observada
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
